var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebitCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 792",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010101;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99,248.5h414.4c6.3,0,11.9,2.6,16,6.7c4.1,4.1,6.7,9.8,6.7,16v45.7v39.7v165c0,6.3-2.6,11.9-6.7,16.1L529,538 c-4.1,3.9-9.6,6.3-15.6,6.3H99c-6.2,0-11.9-2.6-16-6.7l-0.4-0.5c-3.9-4.1-6.3-9.6-6.3-15.6v-165v-39.7v-45.7c0-6.3,2.6-11.9,6.7-16 l0.5-0.4C87.4,250.9,93,248.5,99,248.5L99,248.5z M146.5,433.7h64c3.6,0,6.9,1.5,9.2,3.8c2.4,2.4,3.8,5.6,3.8,9.2v42.8 c0,3.6-1.4,6.9-3.8,9.2c-2.4,2.4-5.6,3.8-9.2,3.8h-64c-3.6,0-6.9-1.5-9.2-3.8c-2.4-2.4-3.8-5.6-3.8-9.2v-42.8c0-3.6,1.5-6.8,3.8-9.2 C139.6,435.2,142.9,433.7,146.5,433.7L146.5,433.7z M209.8,447.4h-62.7v41.5h62.7V447.4z M89.9,310h432.5v-38.8c0-2.5-1-4.8-2.7-6.4 c-1.6-1.6-3.9-2.7-6.4-2.7H99c-2.4,0-4.5,0.9-6.1,2.4l-0.3,0.3c-1.6,1.6-2.7,3.9-2.7,6.4V310z M522.5,363.4H89.9v158.1 c0,2.4,0.9,4.5,2.4,6.1l0.3,0.3c1.6,1.6,3.9,2.7,6.4,2.7h414.4c2.4,0,4.5-0.9,6.1-2.4l0.3-0.3c1.7-1.6,2.7-3.9,2.7-6.4V363.4z  M522.5,323.7H89.9v26h432.5V323.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCardIcon);
export default __webpack_public_path__ + "static/media/debit-card-icon.b19f3c23.svg";
export { ForwardRef as ReactComponent };